import React, { useEffect, useLayoutEffect, useState } from 'react'
import axios from 'axios'
import URL from '../constants/ServerUrl'
import { useNavigate , useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { NepaliDatePicker } from "nepali-datepicker-reactjs"

import { convertDateToAD, convertDateToBS } from '../utils/convertDate'
import { formatDateInBS } from '../utils/formatDate'

const AddPayments = ({ route }) => {
  const navigator = useNavigate()
  const [startDate, setStartDate] = useState(convertDateToBS(Date.now()))
  const [endDate, setEndDate] = useState(convertDateToBS(Date.now()))
  const [isPickerShow, setIsPickerShow] = useState(false)
  const [date, setDate] = useState(new Date(Date.now()))
  const [search, setSearch] = useState('')
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [amountToPay, setAmountToPay] = useState(null)
  const [remarks, setRemarks] = useState('')
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const token = localStorage.getItem("dairy-token")
  const [isLoading, setIsLoading] = useState(false)
  const [focus, setFocus] = useState(false)

  const showPicker = () => {
    setIsPickerShow(true)
  }


  const onChange = ( date) => {
    setStartDate(date)
  }

  useEffect(() => {
    const fetchAllFarmers = async () => {
      try {
        if (username) {
          const farmers = await axios.get(`${URL}admin/${username}/farmer`,{
            Authorization: `Bearer ${token}`,
          })
          const farmersArray = farmers.data.map((farmer) => ({
            farmerName: farmer.farmerName,
            farmerId: farmer.farmerId,
            balance: farmer.credit - farmer.debit,
            
          }))
          setData(farmersArray)
        }
      } catch (error) {
        console.log(error)
      }
    }

    fetchAllFarmers()
  }, [])

  const addPayment = async (farmerId) => {
    try {
      if (username && amountToPay !== 0) {
        setIsLoading(true)
        await axios.post(`${URL}admin/${username}/payment`, {
          farmerId,
          date,
          amountToPay,
          remarks,
        },{
          Authorization: `Bearer ${token}`,
        })

        setAmountToPay(0)
        setRemarks('')
        setIsLoading(false)
        alert('Payment added successfully')
      }

      navigator(-1);
      
    } catch (error) {

      console.log(error)
    }
  }

  const Farmer = ({ farmerName, farmerId }) => (
<button
  onClick={() => {
    setSearch(String(farmerName));
    setFilteredData(data.filter((item) => item.farmerId == farmerId));
    setFocus(false);
  }}
  className="flex flex-col items-start justify-start p-4 bg-white hover:bg-red text-black rounded-md font-semibold shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-300 w-full"
>
  <div className=" text-lg font-bold">
    {farmerId}
  </div>
  <div className="text-sm mt-1 font-bold">
    {farmerName}
  </div>
</button>

  )

  return (
<div className="p-4 bg-gray-50">
<h1 className="text-2xl font-bold text-center text-blue-600 mb-6">ADD PAYMENT</h1>
  <input
    className="border border-gray-300 rounded-md py-2 px-4 mb-6 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
    placeholder="Search by Farmer ID or Name"
    type="text"
    onChange={(e) => {
      setSearch(e.target.value);
      setAmountToPay(0);
      setRemarks('');
      if (e.target.value === '') {
        setFilteredData([]);
      }
    }}
    onFocus={() => setFocus(true)}
    value={search}
  />

  {!focus && filteredData.length > 0 && search !== '' && (
    filteredData.map((item, index) => (
      <div className="border border-gray-300 rounded-lg p-4 mb-6 bg-white" key={index}>
        <div className="mb-3">
          <div className="font-bold text-gray-700">FARMER NAME:</div>
          <div className="text-gray-600">{item.farmerName}</div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-700">FARMER ID:</div>
          <div className="text-gray-600">{item.farmerId}</div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-700">BALANCE:</div>
          <div className="text-gray-600">₹ {item.balance}</div>
        </div>

        <div className="mb-6">
          <div className="flex items-center mb-3">
            {!isPickerShow && (
              <button
                className="border border-gray-300 rounded-md py-2 px-4 text-gray-700 hover:bg-gray-100"
                onClick={showPicker}
              >
                <div>{moment(date).format('DD-MM-YYYY')}</div>
              </button>
            )}

            {isPickerShow && (
              <NepaliDatePicker
                value={startDate}
                onChange={onChange}
                options={{ calenderLocale: 'en', valueLocale: 'en' }}
              />
            )}
          </div>

          <input
            className="border border-gray-300 rounded-md py-2 px-4 mb-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            label="Amount to Pay"
            type="text"
            value={amountToPay > 0 ? amountToPay.toString() : ''}
            onChange={(e) => setAmountToPay(e.target.value)}
          />

          <input
            className="border border-gray-300 rounded-md py-2 px-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Remarks"
            type="text"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>

        <div>
          <button
            className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md"
            disabled={isLoading}
            onClick={() => addPayment(item.farmerId)}
          >
            {isLoading ? 'Paying...' : 'Pay'}
          </button>
        </div>
      </div>
    ))
  )}

  <div className="list-disc pl-4">
    {data
      .filter(({ farmerName, farmerId }) => {
        const searchString = String(search).toLowerCase();
        const lowerCaseFarmerName = farmerName.toLowerCase();
        const stringFarmerId = String(farmerId);

        return (
          lowerCaseFarmerName.includes(searchString) ||
          stringFarmerId.includes(searchString)
        );
      })
      .map((item) => (
        <Farmer
          key={item.farmerId} // Assuming farmerId is unique for each farmer
          farmerId={item.farmerId}
          farmerName={item.farmerName}
          id={item._id}
        />
      ))}
  </div>
</div>


  )
}


export default AddPayments